import * as React from 'react';
import isEmpty from 'lodash/isEmpty';
import { useViewAsUser } from 'src/hooks/api/use-view-as-user';
import { STORAGE_KEYS } from 'src/constants/storage';
import { ENV } from 'src/utils/env';
import { CookieHelper } from 'src/utils/helpers';

export const INTERNAL_DEMO_EMAILS = [
  'fashion.demo@visionr.com',
  'fashion.epos.demo@visionr.com',
  'pharmacy.demo@visionr.com',
  'pharmacy.epos.demo@visionr.com',
];

export const useViewAsButton = (username: string) => {
  const { viewAsUserAsync, isLoading } = useViewAsUser();

  const handleViewAs = async (e: React.SyntheticEvent) => {
    e.preventDefault();
    e.stopPropagation();

    if (isEmpty(username)) return;

    const isInternalDemoUser = INTERNAL_DEMO_EMAILS.includes(username);

    const url = isInternalDemoUser ? `https://app.demo.visionr.com` : ENV.VIEW_AS_URL;

    try {
      const token = await viewAsUserAsync({
        requested_user: username,
      });

      if (token) {
        // set cookie for webapp
        CookieHelper.set({
          name: STORAGE_KEYS.VIEW_AS_TEMP_DETAILS,
          value: JSON.stringify({ token, username, isInternalDemoUser }),
          hours: 1,
          domain: window.origin.toLowerCase().includes('localhost')
            ? 'localhost'
            : '.management.consensusadvertising.com',

          sameSite: 'none',
        });

        // open in incognito window
        window.open(`${url}/view_as`, '_blank');
      }
    } catch (error) {
      console.error('~ file: ViewAsCell.tsx:11 ~ handleClick ~ error:', error);
    }
  };

  return {
    handleViewAs,
    isLoading,
  };
};
